module.exports = __webpack_public_path__ + "static/img/1.6ec9c57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/1.jpg
// module id = PscN
// module chunks = 29